<script>
import appCallouts from "../components/app-callouts";
export default {
  name: "layout-guest",
  components: {
    appCallouts
  }
};
</script>

<template>
  <div class="layout-guest">
    <appCallouts />
    <div id="sapp__view">
      <slot />
    </div>
  </div>
</template>
